<template>
  <div class="pa-8 px-22">
    <header class="mb-8">
      <v-card-title
        class="headline font-weight-bold mb-1 pa-0 letter-spacing-compact"
      >
        Import Community Manager
      </v-card-title>
      <hr />
    </header>
    <div>
      <validation-observer ref="validator">
        <v-form @submit.prevent="findUserByPhoneNumber">
          <ValidationProvider
            name="phone_number"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              name="phone_number"
              :error-messages="errors"
              v-model="request.phone_number"
              label="Phone Number"
              required
            />
          </ValidationProvider>
          <v-btn
            v-if="request.phone_number"
            large
            block
            color="info"
            class="elevation-1 font-weight-bold"
            @click.prevent="findUserByPhoneNumber"
          >
            Search
          </v-btn>
          <template v-if="isFetched">
            <div v-if="user" class="mt-5">
              <div class="d-flex align-center">
                <v-avatar size="70px">
                  <v-img
                    :src="getMedia(user)"
                    :alt="user.name"
                    lazy-src="/placeholder.jpg"
                  />
                </v-avatar>
                <v-list-item color="primary">
                  <v-list-item-content>
                    <v-list-item-title
                      class="title font-weight-bold letter-spacing-compact"
                    >
                      {{ user.full_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ user.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
            <div v-else class="mt-5 mb-5">
              Community Manager not found
            </div>
          </template>
          <v-btn
            v-if="user"
            large
            block
            color="success"
            class="elevation-1 font-weight-bold mt-5"
            @click.prevent="linkOperatorAndCommunityManagers()"
          >
            Import
          </v-btn>
          <v-btn
            v-if="isDrawer"
            large
            color="white"
            class="elevation-1 mb-5 font-weight-bold"
            @click="cancel()"
            block
          >
            Cancel
          </v-btn>
        </v-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import Request from '@request/UserRequest';
import userCrud from '@mixins/userCrud';
import UserModel from '@models/User';

export default {
  name: 'Import',
  mixins: [userCrud],
  metaInfo: {
    titleTemplate: '%s - Manage Community Manager',
  },
  props: {
    isDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      request: new Request(this.$refs),
      model: new UserModel({
        limit: 1,
        page: 1,
      }),
      user: null,
      isFetched: false,
    };
  },
  methods: {
    cancel() {
      this.$refs.validator.reset();
      this.backToList();
    },
    backToList(user) {
      this.$emit('exit', user);
    },
    async findUserByPhoneNumber() {
      if (!this.request.phone_number) {
        return;
      }

      const response = await this.model
        .setFilters({
          phoneNumber: this.request && this.request.phone_number,
        })
        .get();

      if (response) {
        const user = response.data[0];

        this.user = user?.role === 'community-manager' ? user : null;
      }

      this.isFetched = true;
    },
    async linkOperatorAndCommunityManagers() {
      if (await this.$refs.validator.validate()) {
        let response = await this.request.linkOperatorAndCommunityManagers({
          community_manager_ids: [this.user.id],
        });
        if (response) {
          this.request.reset();
          this.backToList(this.user);
        }
      }
    },
  },
};
</script>

<style scoped></style>
